import "swiper/swiper-bundle.css";

import { Autoplay, EffectFade, Navigation, Pagination } from "swiper/modules";

import Swiper from "swiper";

Array.from(document.querySelectorAll("section.quotes .swiper")).map(
	(quotes) => {
		const controls = quotes.querySelector(".swiper__controls");

		const swiper = new Swiper(quotes, {
			modules: [Autoplay, Pagination, EffectFade, Navigation],
			effect: "fade",
			fadeEffect: {
				crossFade: true,
			},
			autoplay: {
				delay: 7500,
			},
			loop: true,
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			on: {
				slideChange: function (swiper) {
					const activeSlide = swiper.slides[swiper.activeIndex];
					const activeColour = activeSlide
						.querySelector("blockquote")
						.getAttribute("data-background");

					console.log(activeColour);

					if (activeColour === "fog") {
						controls.setAttribute("data-theme", "dark");
						return;
					}

					controls.removeAttribute("data-theme");
				},
			},
		});
	}
);
